<template>
    <div class="invoice">
        <el-container>
            <el-header>
                <el-form :inline="true" :model="dataForm">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label-width="100px" label="项目部：">
                                <el-select v-model="dataForm.projectDeptId" placeholder="请选择项目部" @change="getProjectList">
                                    <el-option :label="deptItem.applyDeptName" :value="deptItem.applyDeptId" v-for="(deptItem,deptIndex) in deptList" :key="'deptItem'+deptIndex"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label-width="80px" label="项目名称：">
                                <el-select v-model="dataForm.projectId" placeholder="请选择项目名称">
                                    <el-option :label="projectItem.name" :value="projectItem.id" v-for="(projectItem,projectIndex) in projectList" :key="'projectItem'+projectIndex"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label-width="100px" label="审批编号：">
                                <el-input v-model="dataForm.id" placeholder="请输入审批编号" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <div v-if="showAdvanceFilter">
                            <el-col :span="6">
                                <el-form-item label-width="80px" label="报销审批：">
                                    <el-select v-model="dataForm.approveStatus" placeholder="请选择报销审批">
                                        <el-option label="全部" value=""></el-option>
                                        <el-option label="撤回" :value="1"></el-option>
                                        <el-option label="审批中" :value="2"></el-option>
                                        <el-option label="已通过" :value="3"></el-option>
                                        <el-option label="未通过" :value="4"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>


                            <el-col :span="6">
                                <el-form-item label-width="100px" label="当前审批人：">
                                    <el-input v-model="dataForm.approveUserName" placeholder="请输入当前审批人" clearable></el-input>
                                </el-form-item>
                            </el-col>
                        </div>
                        <el-col :span="showAdvanceFilter? 18 : 6" class="btnRight">
                            <el-form-item class="btnList">
                                <el-button type="primary" @click="query()">查 询</el-button>
                                <el-button type="info" @click="reset()">重 置</el-button>
                                <el-button type="text" @click="moreScreen">{{showAdvanceFilter?'收起':'高级筛选'}}</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-row>
                    <el-col :span="24">
                        <div class="operatePanel">
                            <el-button
                                    type="primary"
                                    icon="el-icon-check"
                                    @click="approveContract()"
                            >报销审批</el-button>
                            <el-button
                                    type="primary"
                                    icon="el-icon-download"
                                    @click="exportBtn()"
                            >导出</el-button>
                        </div>
                    </el-col>
                </el-row>
            </el-header>
            <el-main ref="main">
                <el-table
                        ref="dataTable"
                        :data="invoiceList"
                        highlight-current-row
                        @selection-change="handleSelectionChange"
                        @row-click="rowClicked"
                        size="mini"
                        height="100%"
                        border
                >
                    <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
                    <el-table-column
                            prop="serialNumber"
                            label="审批编号"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="deptName"
                            label="项目部"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="projectName"
                            label="项目名称"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="approveUserName"
                            label="当前审批人"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            label="报销审批"
                            header-align="center" align="center">
                        <template slot-scope="scope">
                            <div type="text" size="small">{{scope.row.approveStatus | setStatus}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" header-align="center" align="center" width="150">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="goToDetails(scope.row)">详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-main>
            <el-footer>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="dataForm.pageIndex"
                        :page-sizes="[10, 20, 30, 50, 100]"
                        :page-size="dataForm.pageSize"
                        layout="total, prev, pager, next, sizes, jumper"
                        :total="total"
                ></el-pagination>
            </el-footer>
        </el-container>

        <!-- 审批弹框 -->
        <el-dialog
                title="项目审批"
                :visible.sync="approvedialogVisible"
                width="30%"
                :before-close="handleClose"
                :close-on-click-modal="false"
        >
            <el-form :model="Approveform" label-width="70px">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="审批编号">
                            <el-input v-model="Approveform.serialNumber" :readonly="true"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="项目名称">
                            <el-input v-model="Approveform.projectName" autocomplete="off" :readonly="true"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="审批意见">
                            <el-input
                                    type="textarea"
                                    :rows="4"
                                    placeholder="请输入内容"
                                    v-model="Approveform.opinion"
                                    maxlength="266"
                                    size="medium"
                                    style="width: 100%;min-width: 266px"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="info" @click="confirmsubContract(4)">驳 回</el-button>
                <el-button type="primary" @click="confirmsubContract(3)">审批通过</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        getDeptListService,
        getProjectListService,
        getApproveListService,
        queryCurrentApproveProcessService,
        submitApproveProcessService,
        exportApproveListService,
    } from '@/services/invoiceServices'
    import {exportExcelService2} from "../../../services/allContractServices";
    export default {
        name: "reimbursement",
        data(){
            return {
                dataForm:{
                    deptId:'',
                    projectId:'',
                    id:'',
                    approveStatus:'',
                    approveUserName:'',
                    pageIndex: 1,
                    pageSize: 10,
                },
                total:0,
                showAdvanceFilter: false,
                deptList:[], //项目部列表
                projectList:[], //项目列表
                invoiceList:[], //表格数据列表
                selectItems:[], //选中的列表

                approvedialogVisible: false,
                //审批对话框form
                Approveform: {
                    approveCode: "",
                    projectName: "",
                    itemId: "", //项目经理id
                    approveUserId: "", //审批人id
                    deptId: "", //部门id
                    opinion: "" //审批意见
                },
            }
        },
        filters:{
            setStatus(val){
                let txt = '';
                if(val == 1){
                    txt = '撤回';
                }else if (val == 2){
                    txt = '审批中';
                }else if (val == 3){
                    txt = '已通过';
                }else if (val == 4){
                    txt = '未通过';
                }
                return txt
            },
        },
        methods:{
            onActive(menuCode) {
                this.getInvoiceList();
                this.getDeptList();
            },
            query(){
                this.getInvoiceList();
            },
            reset(){
                this.dataForm = {
                    deptId:'',
                    projectId:'',
                    id:'',
                    approveStatus:'',
                    approveUserName:'',
                    pageIndex: 1,
                    pageSize: 10,
                }
                this.getInvoiceList();
            },
            /**
             * 获取列表数据
             * */
            getInvoiceList(){
                let paramsData = {
                    ...this.dataForm
                }
                getApproveListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        console.log(res)
                        this.invoiceList = res.data;
                        this.total = res.total;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             *  获取项目部列表
             * */
            getDeptList(){
                getDeptListService().then( res => {
                    if(res.code == 10000000){
                        this.deptList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             *  获取项目列表
             * */
            getProjectList(){
                this.dataForm.projectId = '';
                let paramsData = {
                    deptId: this.dataForm.projectDeptId
                }
                getProjectListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.projectList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            //跳转到审批对话框
            approveContract() {
                if (this.selectItems.length === 1) {
                    if (this.selectItems[0].approveStatus == '已通过') {
                        this.$alert("该销项发票已审批通过", "提示", {
                            confirmButtonText: "确定"
                        });
                        return;
                    }
                    this.getApproveList(this.selectItems[0].id);
                } else {
                    this.$alert("请选择一条发票信息", "提示", {
                        confirmButtonText: "确定"
                    });
                }
            },
            //查询当前审批流
            getApproveList(id) {
                let param = {
                    id: id,
                    approveUserId: sessionStorage.getItem("currentUserId"),
                    type:'INPUT'
                };
                queryCurrentApproveProcessService(param).then(res => {
                    if (res.code == 10000000) {
                        this.approvedialogVisible = true;
                        this.Approveform = { ...res.data };
                        this.Approveform.approveCode = this.selectItems[0].approveCode;
                        this.Approveform.projectName = this.selectItems[0].projectName;
                        this.Approveform.serialNumber = this.selectItems[0].serialNumber;
                    } else {
                        this.$alert(res.msg, "提示", {
                            confirmButtonText: "确定"
                        });
                    }
                })
                .catch(error => {});
            },
            //确认审批分项合同
            confirmsubContract(val) {
                let param = this.Approveform;
                param.status = val; //3：通过 4：驳回
                param.type = 'INPUT'; // 状态 销项发票标识
                if (null == param.opinion || param.opinion == "") {
                    this.$alert("请填写审批备注", "提示", {
                        confirmButtonText: "确定"
                    });
                    return;
                }
                this.$confirm(val == 3?"确认审批该销项发票吗？":"确认驳回该销项发票吗？", "提示", {
                    confirmButtonText: "确认"
                }).then(() => {
                    submitApproveProcessService(param).then(res => {
                        if (res.code == "10000000") {
                            this.$alert(val == 3?"审批成功":"驳回成功", "提示", {
                                confirmButtonText: "确定"
                            });
                            this.query();
                            this.approvedialogVisible = false;
                        } else if (res.code > 20000000) {
                            this.$alert(res.msg, "提示", {
                                confirmButtonText: "确定"
                            });
                        } else {
                            this.$message.error("系统异常");
                        }
                    })
                        .catch(error => {
                            this.$message.error("系统异常");
                        });
                });
            },
            //审批关闭
            handleClose(done) {
                this.$confirm("确认关闭？").then(_ => {
                    done();
                })
                .catch(_ => {});
            },
            moreScreen() {
                this.showAdvanceFilter = !this.showAdvanceFilter;
            },
            // 列代表多选回调
            handleSelectionChange(val) {
                this.selectItems = val;
            },
            // 点击选中行
            rowClicked(row, event, column) {
                this.$refs.dataTable.toggleRowSelection(row);
            },
            // 分页改变事件
            handleCurrentChange(page) {
                this.dataForm.pageIndex = page;
                this.getInvoiceList();
            },
            // 分页显示数量改变事件
            handleSizeChange(rows) {
                this.dataForm.pageIndex = 1;
                this.dataForm.pageSize = rows;
                this.getInvoiceList();
            },
            goToDetails(item){
                this.bus.$emit("navMenuChange", {
                    routeId: "approveDetails",
                    routeParam: {
                        id: item.id
                    }
                });
            },
            exportBtn(){
                let paramsData = {
                    ...this.dataForm,
                    pageSize: 10000,
                }
                exportApproveListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        exportExcelService2(res.data).then(res1 => {
                            this.$message.success('导出成功');
                        });
                        // window.location.href = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .invoice {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
    }
    .btnRight {
        display: flex;
        justify-content: flex-end;
        .btnList{
            text-align: right;
        }
    }
</style>
